import { css, html } from 'react-strict-dom';
import { Api } from 'src/api';
import {
  Avatar,
  DateWithTooltip,
  MarkdownText,
  Stack,
  Text,
} from 'src/components';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';

import UploadsList from './UploadsList';

type Props = {
  body: string | null;
  uploads: Array<Api.Upload.BaseView>;
  isInternal?: boolean;
  author: Api.User.BaseView | null;
  createdAt: string;
};

export default function TimelineComment({
  body,
  uploads,
  isInternal,
  author,
  createdAt,
}: Props) {
  return (
    <Stack
      padH={1.5}
      padV={1.5}
      style={[styles.commentCard, isInternal && styles.commentCardInternal]}
      gap={1}
    >
      <Stack gap={2}>
        <Stack gap={1}>
          <Stack style={[Style.row, Style.alignCenter]} gap={0.5}>
            <Avatar user={author} size={32} />
            {author && (
              <Text typeface="body.medium">
                {author.firstName} {author.lastName}
              </Text>
            )}
            <Text typeface="body.small.regular" color="neutral70">
              <DateWithTooltip timestamp={createdAt} />
            </Text>
          </Stack>

          <MarkdownText body={body} />
        </Stack>

        <UploadsList uploads={uploads} />
      </Stack>

      {isInternal && (
        <html.div style={styles.internalTag}>
          <Text typeface="body.medium" color="blueGrey">
            Internal
          </Text>
        </html.div>
      )}
    </Stack>
  );
}

const styles = css.create({
  commentCard: {
    backgroundColor: color.neutral0,
    borderRadius: 12,
    boxShadow: '0px 16px 16px 0px rgba(0, 0, 0, 0.04)',
    position: 'relative',
  },
  commentCardInternal: {
    backgroundColor: color.neutral10,
    boxShadow: 'none',
  },
  internalTag: {
    backgroundColor: color.blueGreyBg,
    paddingBlock: 2,
    paddingInline: 6,
    borderRadius: 8,
    alignSelf: 'flex-start',
  },
});
